import React, {useEffect, useRef} from 'react';
import {ReadonlyCanvas2} from "./ReadonlyCanvas2";
import {toCountryNameFromCountryId} from "../utils/Util";
import CanvasFrameImg from "../images/top__canvas-frame.png";
import {t4} from "./DrawingDataType";
import gsap from 'gsap';

import {CountryFlag} from "./CountryFlag";
import {CountryLabel} from "./CountryLabel";

export const Smile = (props: { data: t4, mobile: boolean }) => {
    const data = props.data;
    const item = props.data;
    const myRef = useRef<HTMLDivElement>(null);

    let area = item.country ? toCountryNameFromCountryId(item.country) : '';
    area += item.prefecture ? '/' + item.prefecture : '';

    useEffect(() => {
        gsap.to(myRef.current, {duration: 1, opacity: 1});
    }, []);

    return (
        <div className='everyones-smile-item' ref={myRef} style={{opacity: 0}}>
            <div className='everyones-smile-canvas-wrapper'><ReadonlyCanvas2 data={data} size={126}/></div>
            <img className='everyones-smile-frame' src={CanvasFrameImg} alt="" width={315 / 2} height={314 / 2}/>
            {area && <CountryLabel name={area} />}
            {area && <CountryFlag name={item.country}/>}
        </div>
    );
};


